function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgGoogleTranslateOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.166 4H8.245V3h4.921C14.18 3 15 3.82 15 4.833v8.334C15 14.179 14.179 15 13.166 15H8.5v-1h4.666c.46 0 .834-.373.834-.833V4.833A.833.833 0 0 0 13.166 4Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87 4.344c-.59 0-1.133.276-1.522.667-.39.39-.66.93-.66 1.51 0 1.135.793 2.354 2.182 2.354.83 0 1.437-.301 1.814-.848.356-.515.462-1.186.462-1.844h-2.19v.885h1.208a1.51 1.51 0 0 1-.204.46c-.185.267-.495.467-1.09.467-.766 0-1.302-.677-1.302-1.474 0-.305.147-.632.403-.89.256-.256.584-.407.899-.407.641 0 .877.26.917.31l.693-.542c-.202-.259-.692-.648-1.61-.648ZM11.461 6.215h-.872v.848H9.182v.548h3.058c-.146.472-.464 1.04-.925 1.635a6.32 6.32 0 0 1-.685-.98h-.698c.177.486.54 1.005.951 1.5-.255.287-.54.576-.852.86l.459.369a9.35 9.35 0 0 0 .82-.739 22.961 22.961 0 0 0 1.652 1.612l.444-.498a21.993 21.993 0 0 1-1.646-1.61c.62-.74 1.02-1.493 1.172-2.15h1.13v-.547h-2.601v-.848Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.728 13.61 1.804-1.661.678.735-2.37 2.184a.5.5 0 0 1-.813-.208l-.757-2.238.948-.32.51 1.509Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.388 1c.31 0 .582.202.673.497l3.284 10.678a.5.5 0 0 1-.493.647H2.833A1.833 1.833 0 0 1 1 10.99V2.833C1 1.821 1.82 1 2.833 1h4.555ZM7.17 2H2.833A.833.833 0 0 0 2 2.833v8.156c0 .46.373.833.833.833h7.357L7.17 2Zm.218 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgGoogleTranslateOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgGoogleTranslateOutlinedIcon);
export default Memo;